import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import "./App.css";
import { AppHeader } from "./components/app-header.component";
import { ProtectedRoute } from "./components/protected-route.component";
import { AuthProvider } from "./auth/auth-context";
import { ROUTES } from "./routes";
import { AcceptDriverRegistrationView } from "./views/accept-driver-registration/accept-driver-registration.view";
import { DeclineDriverRegistrationView } from "./views/decline-driver-registration/decline-driver-registration.view";
import { DriverRegistrationView } from "./views/driver-registration/driver-registration.view";
import { OrganizationAdminView } from "./views/organization-admin/organization-admin.view";
import { PasswordView } from "./views/password/password.view";

function ProtectedAppLayout() {
  return (
    <ProtectedRoute>
      <div className="protected-app">
        <AppHeader />
        <Outlet />
      </div>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <AuthProvider>
      <main className="app">
        <Routes>
          <Route path={ROUTES.password} element={<PasswordView />} />
          <Route element={<ProtectedAppLayout />}>
            <Route
              path={ROUTES.driverRegistration}
              element={<DriverRegistrationView />}
            />
            <Route
              path={ROUTES.organizationAdmin}
              element={<OrganizationAdminView />}
            />
          </Route>
          <Route
            path={ROUTES.acceptDriverRegistration}
            element={<AcceptDriverRegistrationView />}
          />
          <Route
            path={ROUTES.declineDriverRegistration}
            element={<DeclineDriverRegistrationView />}
          />
          <Route path="*" element={<Navigate to={ROUTES.password} replace />} />
        </Routes>
      </main>
    </AuthProvider>
  );
}

export default App;
